import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo12/Unidad1Actividad6.mp3";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[0];
  const infoAct = modulo12.content[0].activities[7];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo12.content[0].name}: ${modulo12.content[0].activities[8].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[8].path}`,
    titlePrev: `${modulo12.content[0].name}: ${modulo12.content[0].activities[6].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[0].path}/${modulo12.content[0].activities[6].path}`,
  };

  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo12.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12 p-0">
          <ul>
            <li>
              Ahora, haremos una encuesta a nuestros amigos, amigas o
              familiares. ¿Sabes dónde nacieron y de dónde vienen sus familias?
            </li>
            <li>
              Elige a dos amigos, amigas o familiares y completa la siguiente
              tabla.
            </li>
          </ul>
        </div>
      </div>
      <div>
        <h5 className="mt-5 mb-3">ENCUESTA 1</h5>

        <table className="table table-bordered border-primary align-middle">
          <tbody>
            <tr>
              <td className="w-200">
                <p className="mb-0">Nombre de mi amigo(a):</p>
              </td>
              <td>
                <input className="form-control" type="text" />
              </td>
            </tr>
            <tr>
              <td>
                <p className="mb-0">Lugar de nacimiento:</p>
              </td>
              <td>
                {" "}
                <input className="form-control" type="text" />
              </td>
            </tr>
            <tr>
              <td>
                <p className="mb-0">Lugar de origen de su familia:</p>
              </td>
              <td>
                {" "}
                <input className="form-control" type="text" />
              </td>
            </tr>
          </tbody>
        </table>

        <h5 className="mt-5 mb-3">ENCUESTA 2</h5>

        <table className="table table-bordered border-primary align-middle">
          <tbody>
            <tr>
              <td className="w-200">
                <p className="mb-0">Nombre de mi amigo(a):</p>
              </td>
              <td>
                <input className="form-control" type="text" />
              </td>
            </tr>
            <tr>
              <td>
                <p className="mb-0">Lugar de nacimiento:</p>
              </td>
              <td>
                {" "}
                <input className="form-control" type="text" />
              </td>
            </tr>
            <tr>
              <td>
                <p className="mb-0">Lugar de origen de su familia:</p>
              </td>
              <td>
                {" "}
                <input className="form-control" type="text" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las indicaciones: Ahora, haremos una encuesta a nuestros amigos
            y amigas. ¿Sabes dónde nacieron y de dónde vienen sus familias?
            Elige dos amigos o amigas y completa la siguiente tabla.
          </li>

          <li>
            Explique que las encuestas son una técnica para recoger datos sobre
            un tema específico. Para ello se aplica un cuestionario a un número
            determinado de personas.
          </li>

          <li>
            Pida a niñas y niños que trabajen en grupos o con un familiar y que
            llenen los datos que se piden en la encuesta para los dos compañeros
            o compañeras elegidas: nombre, lugar de nacimiento y lugar de origen
            de la familia.
          </li>

          <li>
            Pida algunas respuestas y conversen al respecto. Puede preguntar,
            por ejemplo:
            <ul>
              <li>
                <i>
                  “¿En qué ciudad han nacido? ¿Cuántos son de ese lugar? ¿Son
                  muchos los que no nacieron aquí? ¿De cuántos lugares provienen
                  las distintas familias de la clase?”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Finalice la actividad señalando que existen familias que vienen de
            distintas partes del Perú. Eso es muy común en nuestro país porque
            la migración es usual.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
